import { render, staticRenderFns } from "./GoodNews.vue?vue&type=template&id=973d5d8e&scoped=true"
import script from "./GoodNews.vue?vue&type=script&lang=js"
export * from "./GoodNews.vue?vue&type=script&lang=js"
import style0 from "./GoodNews.vue?vue&type=style&index=0&id=973d5d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973d5d8e",
  null
  
)

export default component.exports